export var CentralProviderErrorTypes;
(function (CentralProviderErrorTypes) {
    CentralProviderErrorTypes["DEFAULT"] = "DEFAULT";
    CentralProviderErrorTypes["NO_GRANT"] = "NO_GRANT";
    CentralProviderErrorTypes["CALLBACK_ERROR_UNAUTHORIZED"] = "CALLBACK_ERROR_UNAUTHORIZED";
    CentralProviderErrorTypes["USER_DEACTIVATED"] = "USER_DEACTIVATED";
    CentralProviderErrorTypes["APP_OFFLINE"] = "APP_OFFLINE";
})(CentralProviderErrorTypes || (CentralProviderErrorTypes = {}));
//# sourceMappingURL=centralProviderErrors.js.map